module.exports = __webpack_public_path__ + "static/media/gift_certificate.41da5c79.png";